import { useRouter } from "next/router";
import type { ReactNode } from "react";
import { FetchLoader } from "src/component/element/FetchLoader";
import { useGetUserSettingsQuery } from "src/service/UsersApi";

export const RegistrationCheck = ({
  children,
}: {
  children: ReactNode;
}): any => {
  const router = useRouter();
  const { data: user, isLoading } = useGetUserSettingsQuery();

  if (isLoading || !user) {
    return <FetchLoader />;
  }

  if (user) {
    if (user.role == "COACH") {
      return <>{children}</>;
    } else if (user.role == "STUDENT") {
      if (user.userCourses.length < 1) {
        if (user.useBankTransfer) {
          router.push({
            pathname: "/plans",
            query: { useBankTransfer: user.useBankTransfer },
          });
        } else {
          if (user.stripeId) {
            router.push({
              pathname: "/payment_confirmation",
              query: {
                stripeId: user.stripeId,
                useBankTransfer: user.useBankTransfer,
              },
            });
          } else if (user.registeredCourseId?.length) {
            router.push({
              pathname: `/plans/${user.registeredCourseId}`,
            });
          } else {
            router.push({
              pathname: "/plans",
              query: {
                useBankTransfer: user.useBankTransfer,
              },
            });
          }
        }
      } else if (!user.lineId) {
        router.push("/auth/line");
      } else {
        return <>{children}</>;
      }
    } else if (user.role == "FREE_USER") {
      if (!user.lineId) {
        router.push("/auth/line");
      } else {
        return <>{children}</>;
      }
    } else {
      return <>{children}</>;
    }
  }
  return <></>;
};
